module.exports = __webpack_public_path__ + "assets/img/IMG006.482347c2.png";